import push from "./push";
import { ConversionItemModel } from "..";

/**
 * Sends a `subscribe` event for Google Tag Manager
 * https://developers.google.com/tag-manager/devguide#multipush
 */
export default function pushSubscribe(
    orderId: string,
    offerCode: string,
    orderTotal: number,
    subtotal: number,
    isSoftDecline: string,
    pageType: string | null,
    hashedEmail: string,
    items: ConversionItemModel[] | null
): Promise<void> {
    // Per RM6784, we are sending a single Google Subscribe event with:
    // - Advantage order ID
    // - The promotion code
    // - The order total

    //UPDATE: Per RM7154 - Additional parameters have been added to avoid sending multiple conversion events

    return push("subscribe", {
        "subscription-id": orderId,
        "order-id": orderId,
        "order-total": orderTotal.toFixed(2),
        "order-subtotal": subtotal.toFixed(2),
        "offer-code": offerCode,
        "is-soft-decline": isSoftDecline,
        "page-type": pageType,
        "items": items,
        // offer code is duplicated here because we added "promotioncode" to several other events. This way
        // the name matches for all the events. "offer-code" is not modified because it might be used by something
        // else and changing that would break something.
        "promotioncode": offerCode,
        "hashed-email": hashedEmail
    });
}
